import { render } from "./Q1Simple.vue?vue&type=template&id=39d25557"
import script from "./Q1Simple.vue?vue&type=script&lang=js"
export * from "./Q1Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__